export const TUTORIAL_DESIGN_COMPLETED = "tutorial_design_completed";
export const TUTORIAL_EDIT_COMPLETED = "tutorial_edit_completed";
export const TUTORIAL_TRAIN_COMPLETED = "tutorial_train_completed";
export const DOWNLOAD_SETTING = "refabric_download_setting";
// REF-5701: persisted state of the "Include AI Generated" download toggle (boolean).
export const DOWNLOAD_AI_LABEL_SETTING = "refabric_download_ai_label";
export const SHORT_TUTORIAL_DESIGN_SHOWN = "short_tutorial_design_shown";
export const SHORT_TUTORIAL_EDIT_SHOWN = "short_tutorial_edit_shown";
export const SHORT_TUTORIAL_TRAINING_SHOWN = "short_tutorial_training_shown";
export const DO_NOT_SHOW_ACCURATE_COLOR_TIP = "do_not_show_accurate_color_tip";
export const DO_NOT_SHOW_TRYON_DOWNLOAD_TIP = "do_not_show_tryon_download_tip";
export const DO_NOT_SHOW_GET_BETTER_RESULT_TIP = "do_not_show_get_better_result_tip";
export const DO_NOT_SHOW_REFERENCE_IMAGE_TIP = "do_not_show_reference_image_tip";
export const DO_NOT_SHOW_PROMPT_ERASE_TIP = "do_not_show_prompt_erase_tip";

// With site data blocked, merely reading `window.localStorage` throws a SecurityError (Sentry 7816782090). Writes and
// removes are best-effort: a preference simply does not persist, and logout / the 401 branch still reach their redirect.
// NOTE this does NOT make a session work without storage — token readers (AuthorizationPage, Router, sockets) read back
// from here and get null, so a blocked-storage user stays logged out. Out of scope by decision; only the crashes go.
export const useLocalStorage = () => {
  return {
    setItem: (key: string, data: any) => {
      // Serialize outside the guard: an unserializable value (cycle, BigInt) is a caller bug and must still throw.
      const serialized = JSON.stringify(data);

      try {
        window.localStorage.setItem(key, serialized);
      } catch {
        // Storage blocked, private mode or quota — the value is simply not persisted.
      }
    },
    getItem: (key: string) => {
      try {
        const data = window.localStorage.getItem(key);

        return JSON.parse(data as string);
      } catch {
        return null;
      }
    },
    removeItem: (key: string) => {
      try {
        window.localStorage.removeItem(key);
      } catch {
        // Storage blocked — nothing readable to remove (getItem already returns null).
      }
    },
  };
};
